import { NgIf } from '@angular/common';
import {
  Component,
  inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { AlertAdvisoriesUiComponent } from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  AnalyticsDataPopulateService,
  FlyoutLangSelectorFacade
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { Advisory } from '../../../data-access/constants/alert-advisories/alert-advisories-constants';
import { AlertAdvisoriesFacade } from '../../../data-access/facades/alert-advisories/alert-advisories.facade';

@Component({
  selector: 'idp-alert-advisories-container',
  standalone: true,
  imports: [NgIf, AlertAdvisoriesUiComponent],
  templateUrl: './alert-advisories.component.html',
  styleUrls: ['./alert-advisories.component.scss']
})
export class AlertAdvisoriesComponent implements OnInit, OnChanges {
  flyoutLangSelectorFacade = inject(FlyoutLangSelectorFacade);
  alertAdvisoriesFacade = inject(AlertAdvisoriesFacade);
  analyticsService = inject(AnalyticsDataPopulateService);
  @Input() displayCloseIcon = false;
  @Input() hamburgerMenuOpen = false;

  ngOnInit(): void {
    this.alertAdvisoriesFacade.init();
  }

  ngOnChanges(changes: SimpleChanges) {
    const shouldHide =
      changes['hamburgerMenuOpen']?.currentValue ||
      changes['displayCloseIcon']?.currentValue;
    this.alertAdvisoriesFacade.showAlertAdvisoriesHeader.set(!shouldHide);
  }

  close(screenName: string): void {
    if (screenName == Advisory) this.alertAdvisoriesFacade.close();
    else this.flyoutLangSelectorFacade.showSelectorModal.set(true);
  }

  handleAnalytics(element: HTMLElement): void {
    this.analyticsService.populateAnalyticsData(element);
  }
}
